import type { Locale } from '../../Entities/Locale/Locale.entity';

//TODO: This fn is not redundant, replace usages with returned string
export const getReviewsPathSegment = (_locale: Locale) => {
  return 'reviews';
};
